export const TIME_MINUTES_INVERVAL = 15;
export const ONE_SECOND = 1000;
export const HALF_OF_MINUTE = 30 * ONE_SECOND;
export const ONE_MINUTE = 60 * ONE_SECOND;
export const FIVE_MINUTES = 5 * ONE_MINUTE;
export const ONE_HOUR = 60 * ONE_MINUTE;
export const ONE_DAY = 24 * ONE_HOUR;
export const MINUTES_IN_ONE_DAY = 60 * 24;
